import { acceptBooleanValue } from '../../field-viewer/shared-normalizers';
export const checkboxViewer = {
    normalizeLoadedValue: acceptBooleanValue
};

//# sourceMappingURL=definition-viewer.js.map